import { DataAccessService } from "./basic.service";

class ControlCommandsDAService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName)
    }

    private sendCommand(Command: string, deviceIds: string | string[]) {
        if (typeof deviceIds === 'string') {
            return this.add({
                Command,
                deviceId: deviceIds
            });
        }

        return Promise.all(deviceIds.map((deviceId) => this.add({ Command, deviceId})))
    }

    reboot(deviceIds: string[]) {
        return this.sendCommand('Reboot', deviceIds)
    }

    getLogs(deviceIds: string | string[]) {
        return this.sendCommand('GetLogs', deviceIds)
    }

    takeSnapshot(deviceIds: string | string[]) {
        return this.sendCommand('Screenshot', deviceIds)
    }

    takeTabletScreenshot(deviceIds: number[]) {
        
        deviceIds.forEach(async (deviceId) => {
            this.add({
                Command: 'TabletScreenshot',
                deviceId
            });
        })
    }

    clearCacheAndReloadTablets(deviceIds: number[]) {
        deviceIds.forEach(async (deviceId) => {
            this.add({
                Command: 'TabletReload',
                deviceId
            });
        })
    }
}
export default new ControlCommandsDAService('control_commands');